import React, { useState } from "react";
import { PublicShell } from "@/components/PublicNav";
import { Mail, MapPin, MessageCircle } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/public/contact", form);
      toast.success("Message sent! We'll get back to you within 24 hours.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <PublicShell>
      <section className="zq-hero-bg">
        <div className="max-w-5xl mx-auto px-5 md:px-8 py-16 md:py-20 text-center">
          <span className="zq-pill zq-pill-orange">Contact</span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mt-4">Let's talk.</h1>
          <p className="text-zq-muted mt-5 max-w-2xl mx-auto">Demos, partnerships, or any question — drop us a line.</p>
        </div>
      </section>

      <section className="zq-section pt-0">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8">
          <form className="zq-card p-6" onSubmit={submit} data-testid="contact-form">
            <label className="block text-sm font-medium mb-1">Name</label>
            <input className="zq-input mb-4" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" />
            <label className="block text-sm font-medium mb-1">Email</label>
            <input className="zq-input mb-4" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" />
            <label className="block text-sm font-medium mb-1">Phone</label>
            <input className="zq-input mb-4" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="contact-phone" />
            <label className="block text-sm font-medium mb-1">Message</label>
            <textarea className="zq-input mb-4" rows={5} required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />
            <button className="zq-btn zq-btn-primary w-full" disabled={loading} data-testid="contact-submit">
              {loading ? "Sending…" : "Send message"}
            </button>
          </form>

          <div className="space-y-5">
            <div className="zq-card p-5 flex gap-4">
              <Mail className="text-zq-orange shrink-0" />
              <div>
                <div className="font-semibold">Email</div>
                <div className="text-sm text-zq-muted">zaykaqr@gmail.com</div>
              </div>
            </div>
            <div className="zq-card p-5 flex gap-4">
              <MapPin className="text-zq-orange shrink-0" />
              <div>
                <div className="font-semibold">Office</div>
                <div className="text-sm text-zq-muted"> Junagadh, Gujarat 362001</div>
              </div>
            </div>
            <a
              href="https://wa.me/919313070872?text=Hi%20ZaykaQR%2C%20I%27d%20like%20to%20learn%20more"
              target="_blank"
              rel="noreferrer"
              className="zq-btn zq-btn-whatsapp w-full"
              data-testid="contact-whatsapp"
            >
              <MessageCircle size={18}/> Chat on WhatsApp
            </a>
          </div>
        </div>
      </section>
    </PublicShell>
  );
};
